import {
  DatePicker,
  Dropdown,
  IDropdownOption,
} from "@fluentui/react";
import React, { useContext } from "react";
import { format } from "date-fns";
import { ColumnOptionsContext } from "./ColumnOptions";
import {
  Column,
  DateFilter as DateFilterType,
  DateFilterOperator,
  dateFilterOperators,
} from "./types";

const capitalize = (s: string) =>
  s.length > 0 ? `${s[0].toUpperCase()}${s.slice(1)}` : "";

const formatDate = (date: Date) => format(date, "dd.MM.yyyy");

type Props = {
  column: Column;
};

export const DateFilter = ({ column }: Props) => {
  const filter = column.filter as DateFilterType;
  const { setFilter, strings, filterProps } =
    useContext(ColumnOptionsContext);

  const operatorOptions: IDropdownOption[] = dateFilterOperators.map((o) => ({
    key: o,
    text: (strings as any)[`dateFilterOperator${capitalize(o)}Label`],
  }));

  let date1Props: any = filterProps
    ? filterProps[column.key]?.date1
    : undefined;
  let date2Props: any = undefined;

  if (filter.operator === "isBetween") {
    date1Props = {
      ...(date1Props || {}),
      maxDate: filter.date2 ?? date1Props?.maxDate,
    };
    date2Props = filterProps
      ? filterProps[column.key]?.date2
      : undefined;
    date2Props = {
      ...(date2Props || {}),
      minDate: filter.date1 ?? date2Props?.minDate,
    };
  }

  return (
    <div>
      <Dropdown
        selectedKey={filter.operator}
        options={operatorOptions}
        onChange={(_, option) => {
          if (!option) return;
          setFilter(column.key, {
            ...filter,
            operator: option.key as DateFilterOperator,
          });
        }}
        styles={{ root: { marginBottom: 4 } }}
      />
      <DatePicker
        value={filter.date1 ?? undefined}
        onSelectDate={(date) => {
          setFilter(column.key, {
            ...filter,
            date1: date ?? null,
          });
        }}
        formatDate={(date) => (date ? formatDate(date) : "")}
        strings={strings.datePickerStrings}
        {...date1Props}
        styles={{ root: { marginBottom: 4 } }}
      />
      {filter.operator === "isBetween" && (
        <DatePicker
          value={filter.date2 ?? undefined}
          onSelectDate={(date) => {
            setFilter(column.key, {
              ...filter,
              date2: date ?? null,
            });
          }}
          formatDate={(date) => (date ? formatDate(date) : "")}
          strings={strings.datePickerStrings}
          {...date2Props}
        />
      )}
    </div>
  );
};
